import { render, staticRenderFns } from "./KeycloakLogin.vue?vue&type=template&id=22af72fd&scoped=true&"
import script from "./KeycloakLogin.vue?vue&type=script&lang=js&"
export * from "./KeycloakLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af72fd",
  null
  
)

export default component.exports